import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useDispatch, useSelector } from 'react-redux';
import { NavItem } from './components';
import { Avatar } from '@mui/material';
import { Logout } from '@mui/icons-material';
import MenuIcon from '@mui/icons-material/Menu';
import { updateNotificationPreferencesThunk } from 'redux/slices/miscSlice';
import { checkSession, logoutUser, resetUIState } from 'redux/slices/authSlice';

const TopNavbarItems = ({ onSidebarOpen }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const [, setActiveLink] = useState('');
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  const userDetails = useSelector((state) => state.userDetails.userDetails);

  // const {
  //   landings: landingPages,
  //   secondary: secondaryPages,
  //   company: companyPages,
  //   account: accountPages,
  //   portfolio: portfolioPages,
  //   blog: blogPages,
  // } = pages;

  const handleLogoutClick = async () => {
    if (localStorage.getItem('notificationToken')) {
      try {
        await dispatch(
          updateNotificationPreferencesThunk({ pushnotification: false }),
        ).unwrap();
        localStorage.removeItem('notificationToken');
      } catch (_e) {
        /* noop */
      }
    }
    dispatch(logoutUser())
      .unwrap()
      .then(() => {
        dispatch(resetUIState());
        dispatch(checkSession());
      })
      .catch(() => {
        dispatch(resetUIState());
        dispatch(checkSession());
      });
  };
  useEffect(() => {
    setActiveLink(window && window.location ? window.location.pathname : '');
  }, []);

  return (
    <Box
      height={1}
      display={'flex'}
      flexDirection={'row'}
      alignItems={'center'}
      // justifyContent={'space-between'}
    >
      <Box height={1} display={'flex'} alignItems={'center'}>
        <Button
          onClick={() => onSidebarOpen()}
          aria-label="Menu"
          variant={'text'}
          sx={{
            // borderRadius: 2,
            minWidth: 'auto',
            // padding: 1,
            // borderColor: alpha(theme.palette.divider, 0.2),
          }}
        >
          <MenuIcon />
        </Button>
        <Box
          display={'flex'}
          component="a"
          href={'https://dealcopilot.ai/'}
          title={'Deal Copilot'}
          width={34}
          height={34}
        >
          {/*
            Was swapping to a pure-white `/dark_theme_logo.svg` here while the
            sidebar left the same mark charcoal, so the logo rendered two
            different colours in dark mode depending on which chrome you were
            looking at. One artwork, re-toned by `--dc-logo-filter`, keeps them
            identical.
          */}
          <Box
            component={'img'}
            src={'/dh-icons/logo.svg'}
            height={1}
            width={1}
            sx={{ filter: 'var(--dc-logo-filter)' }}
          />
        </Box>
      </Box>
      <Box display={'flex'} alignItems={'center'} ml={'auto'}>
        {/* <Box>
          <NavItem
            title={'Contests'}
            items={[]}
            href={'/contests'}
            startIcon={'/contest.svg'}
          />
        </Box> */}
        {/* <Box>
          <NavItem
            title={'Practice'}
            items={[]}
            href={'/practice'}
            startIcon={'/practice1.svg'}
          />
        </Box> */}
        {/* {userInfo?.designations?.includes('candidate') ? ( */}
        <Box>
          <NavItem
            title={'Profile'}
            items={[]}
            href={'/profile'}
            startIcon={
              <Avatar
                variant="square"
                alt={userInfo?.firstName?.toUpperCase()}
                src={userDetails?.profilePicture?.url}
                sx={{
                  width: 20,
                  height: 20,
                }}
              >
                {userInfo?.firstName?.[0]?.toUpperCase()}
              </Avatar>
            }
          />
        </Box>
        {/* // ) : null} */}
        <Box>
          <NavItem
            title={'Logout'}
            items={[]}
            // href={'/account'}
            startIcon={
              <Logout style={{ color: theme.palette.text.secondary }} />
            }
            action={handleLogoutClick}
          />
        </Box>
      </Box>
    </Box>
  );
};

TopNavbarItems.propTypes = {
  onClose: PropTypes.func,
  expanded: PropTypes.bool,
  onSidebarOpen: PropTypes.func,
};

export default TopNavbarItems;
